import PropTypes from 'prop-types';
import { FormProvider, useForm } from 'react-hook-form';
import { useParams } from 'react-router';
import PathwayFields from './PathwayFields';
import CustomPropertiesPanel from './CustomPropertiesPanel';
import ExportUnitsPanel from './ExportUnitsPanel';
import ParamsProvider from '../../providers/ParamProvider';
import { patchPathwayParams } from '@/api/pathways';
import { caseActions } from '@/stores/caseStore';
import SettingsPanel from '@/components/core/SettingsPanel';
import { pathwayParamsActions } from '@/stores/pathwayParamsStore';

const updatePathwayParams = async (params, urlParams) => {
  const { pathwayId } = urlParams;
  const { data } = await patchPathwayParams(pathwayId, params);

  pathwayParamsActions.init(data.params);
  caseActions.markUnbalanced();

  return data;
};

const PathwaySettingsForm = ({ params, paramSchemas }) => {
  const { pathwayId } = useParams();
  const methods = useForm();
  const { handleSubmit, reset } = methods;
  const onInnerSubmit = async data => reset(data);

  return (
    <ParamsProvider patch={updatePathwayParams}>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onInnerSubmit)} noValidate>
          <div className="space-y-4">
            <SettingsPanel title="Global">
              <PathwayFields params={params} paramSchemas={paramSchemas} />
            </SettingsPanel>
            <div className="flex flex-col gap-4 xl:flex-row xl:items-start">
              <div className="w-full xl:w-1/2">
                <CustomPropertiesPanel key={pathwayId} />
              </div>
              <div className="w-full xl:w-1/2">
                <ExportUnitsPanel />
              </div>
            </div>
          </div>
        </form>
      </FormProvider>
    </ParamsProvider>
  );
};

PathwaySettingsForm.propTypes = {
  params: PropTypes.object,
  paramSchemas: PropTypes.arrayOf(PropTypes.object),
};

export default PathwaySettingsForm;
